<div>
  <button class="warn transparent" mat-flat-button [class.waiting]="waiting" (click)="doRemove()">
    <ng-container *ngIf="!waiting"> {{ 'button.remove' | translate }} </ng-container>
    
    <mat-spinner *ngIf="waiting" [diameter]="20"></mat-spinner>
  </button>
</div>
